import { create } from 'zustand';

interface DialogStore {
  isOpen: boolean;
  title: string;
  description: string;
  confirmText: string;
  cancelText: string;
  variant: 'danger' | 'warning' | 'info';
  onConfirm: () => void;
  onCancel: () => void;
  setDialog: (dialog: Partial<DialogStore>) => void;
  reset: () => void;
}

const initialState = {
  isOpen: false,
  title: '',
  description: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  variant: 'info' as const,
  onConfirm: () => {},
  onCancel: () => {},
};

const useDialogStore = create<DialogStore>((set) => ({
  ...initialState,
  setDialog: (dialog) => set(dialog),
  reset: () => set(initialState),
}));

export const useDialog = () => {
  const dialogStore = useDialogStore();

  const showDialog = ({
    title,
    description,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'info',
  }: {
    title: string;
    description: string;
    confirmText?: string;
    cancelText?: string;
    variant?: 'danger' | 'warning' | 'info';
  }) => {
    return new Promise<boolean>((resolve) => {
      dialogStore.setDialog({
        isOpen: true,
        title,
        description,
        confirmText,
        cancelText,
        variant,
        onConfirm: () => {
          dialogStore.reset();
          resolve(true);
        },
        onCancel: () => {
          dialogStore.reset();
          resolve(false);
        },
      });
    });
  };

  return {
    showDialog,
    ...dialogStore,
  };
};
